import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/__authed/m/repairs/problematic")({
	beforeLoad() {
		throw redirect({
			to: "/m/repairs",
			search: {
				page: 1,
				limit: 25,
				states: "problematic",
			},
		});
	},
});
